"use client";

import { useState } from "react";
import { SERVICES, EXPERTS } from "@/lib/data";

export default function BookingForm() {
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <div className="rounded-2xl border border-honey-200 bg-honey-50 p-8 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-honey-500 text-2xl text-white">
          ✓
        </div>
        <h3 className="mt-4 font-serif text-xl text-charcoal">
          Request received
        </h3>
        <p className="mt-2 text-charcoal/70">
          Thank you! We&apos;ll be in touch shortly to confirm your appointment.
        </p>
        <button
          onClick={() => setSubmitted(false)}
          className="btn-outline mt-6"
        >
          Send another request
        </button>
      </div>
    );
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setSubmitted(true);
      }}
      className="space-y-5"
    >
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="First name" name="firstName" required />
        <Field label="Last name" name="lastName" required />
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Email" name="email" type="email" required />
        <Field label="Phone" name="phone" type="tel" required />
      </div>

      <div className="grid gap-5 sm:grid-cols-2">
        <label className="block">
          <span className="mb-1.5 block text-sm font-medium text-charcoal/80">
            Service
          </span>
          <select
            name="service"
            className="w-full rounded-xl border border-honey-200 bg-white px-4 py-3 text-sm text-charcoal outline-none transition focus:border-honey-400 focus:ring-2 focus:ring-honey-200"
            defaultValue=""
          >
            <option value="" disabled>
              Choose a service
            </option>
            {SERVICES.map((c) => (
              <optgroup key={c.name} label={c.name}>
                {c.items.map((i) => (
                  <option key={i.name} value={i.name}>
                    {i.name}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-1.5 block text-sm font-medium text-charcoal/80">
            Preferred stylist
          </span>
          <select
            name="stylist"
            className="w-full rounded-xl border border-honey-200 bg-white px-4 py-3 text-sm text-charcoal outline-none transition focus:border-honey-400 focus:ring-2 focus:ring-honey-200"
            defaultValue="any"
          >
            <option value="any">No preference</option>
            {EXPERTS.map((e) => (
              <option key={e.name} value={e.name}>
                {e.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      <Field label="Preferred date" name="date" type="date" />

      <label className="block">
        <span className="mb-1.5 block text-sm font-medium text-charcoal/80">
          Anything we should know?
        </span>
        <textarea
          name="notes"
          rows={4}
          className="w-full rounded-xl border border-honey-200 bg-white px-4 py-3 text-sm text-charcoal outline-none transition focus:border-honey-400 focus:ring-2 focus:ring-honey-200"
          placeholder="Tell us about your hair goals…"
        />
      </label>

      <button type="submit" className="btn-primary w-full">
        Request appointment
      </button>
      <p className="text-center text-xs text-charcoal/40">
        This is a demo form — submissions are not sent anywhere.
      </p>
    </form>
  );
}

function Field({
  label,
  name,
  type = "text",
  required = false,
}: {
  label: string;
  name: string;
  type?: string;
  required?: boolean;
}) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-sm font-medium text-charcoal/80">
        {label} {required && <span className="text-honey-600">*</span>}
      </span>
      <input
        type={type}
        name={name}
        required={required}
        className="w-full rounded-xl border border-honey-200 bg-white px-4 py-3 text-sm text-charcoal outline-none transition focus:border-honey-400 focus:ring-2 focus:ring-honey-200"
      />
    </label>
  );
}
